const TRANSFER_ACCOUNT_DATA_NUM_STEPS = 6;

export const getProgressPercent = (currentStep: number) =>
  currentStep / TRANSFER_ACCOUNT_DATA_NUM_STEPS;
